import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme/theme';
import './lib/chartSetup';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './layouts/DashboardLayout';
import Login from './pages/Login';
import AutoLogin from './pages/AutoLogin';
import Dashboard from './pages/Dashboard';
import Employees from './pages/Employees';
import EmployeeDetail from './pages/EmployeeDetail';
import Attendance from './pages/Attendance';
import UsageReports from './pages/UsageReports';
import ProductivityRating from './pages/ProductivityRating';
import AppBlocking from './pages/AppBlocking';
import Settings from './pages/Settings';

export default function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/autologin" element={<AutoLogin />} />
                        <Route
                            element={
                                <ProtectedRoute>
                                    <DashboardLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route path="/" element={<Dashboard />} />
                            <Route path="/employees" element={<Employees />} />
                            <Route path="/employees/:user_id" element={<EmployeeDetail />} />
                            <Route path="/attendance" element={<Attendance />} />
                            <Route path="/usage" element={<UsageReports />} />
                            <Route path="/rating" element={<ProductivityRating />} />
                            <Route path="/blocking" element={<AppBlocking />} />
                            <Route path="/settings" element={<Settings />} />
                        </Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </ThemeProvider>
    );
}
